import React from "react";
import "../Styles/Stats.css";
import {
  FaUserMd,
  FaTooth,
  FaHospitalAlt,
  FaSmileBeam,
  FaStar,
  FaTeeth,
} from "react-icons/fa";

const statsData = [
  { icon: <FaSmileBeam />, number: "3 Million +", label: "Happy Patients" },
  { icon: <FaTeeth />, number: "35,000 +", label: "Successful Ortho Cases" },
  { icon: <FaTooth />, number: "55,000 +", label: "Implants Placed" },
  { icon: <FaUserMd />, number: "1300 +", label: "Doctors" },
  { icon: <FaHospitalAlt />, number: "600 +", label: "Clinics" },
  { icon: <FaStar />, number: "2 Lakhs +", label: "Google Reviews" },
];

const Stats = () => {
  return (
    <div className="contact-stats-container">
      {statsData.map((item, idx) => (
        <div className="stat-box" key={idx}>
          <div className="stat-icon">{item.icon}</div>
          <div className="stat-number">{item.number}</div>
          <div className="stat-label">{item.label}</div>
        </div>
      ))}
    </div>
  );
};

export default Stats;
